const SIGN_IN_PATH = '/auth/signin';

export function buildPatientPortalUrl(patientPortalDomain) {
  const domain = String(patientPortalDomain || '').trim();
  if (!domain) return SIGN_IN_PATH;

  return `${domain.replace(/\/+$/, '')}${SIGN_IN_PATH}`;
}
